export enum AuthTokenError {
  LOGIN_REQUIRED = 'login_required',
  INVALID_SCOPE = 'invalid_scope',
}

export const hasAuthTokenError = (error: unknown, errorType: AuthTokenError) =>
  JSON.stringify(error).includes(errorType)
